import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export const HtmlDescription = ({
  content,
  size = 'base',
  className,
  color,
}: {
  content: string;
  className?: string;
  size?: 'sm' | 'base';
  color?: 'white' | 'black' | 'foreground' | 'muted-foreground';
}) => {
  return (
    <HtmlRendererRaw
      html={content}
      className={cn(
        'ea-html-description',
        className,
        size === 'sm' && 'ea-html-description--sm',
        size === 'base' && 'ea-html-description--base',
        color === 'white' && 'text-white',
        color === 'black' && 'text-black',
        color === 'foreground' && 'text-foreground',
        color === 'muted-foreground' && 'text-muted-foreground',
      )}
    />
  );
};
